export default __webpack_public_path__ + "static/media/action-arrow-down_darkGray2.4a001f9a.svg";